module.exports = __webpack_public_path__ + "img/ampel_pin_rot.0446b934.svg";